export default __webpack_public_path__ + "static/media/02.754943a1.jpg";